import { HideImage } from "@mui/icons-material";
import { Box } from "@mui/material";
import { QueryErrorResetBoundary } from "@tanstack/react-query";
import type React from "react";
import { Suspense } from "react";
import { ErrorBoundary } from "react-error-boundary";
import { useGetApiAssetsmultimediaAdvertisementIdGallerySuspense } from "../../../api/rest/generated/assets-multimedia/assets-multimedia.ts";
import SzBackdrop from "../UISharedConstructors/Loading/SzBackDrop.tsx";
import SzCarousel from "./SzCarousel.tsx";

const Images: React.FC<{ id: number }> = ({ id }) => {
	const detail = useGetApiAssetsmultimediaAdvertisementIdGallerySuspense(id, {
		query: {
			retry: false,
		},
	});
	const images = detail.data;

	return <SzCarousel infinite={true} images={images} />;
};

const ImagesSection: React.FC<{ id: number }> = ({ id }) => {
	return (
		<Suspense
			fallback={
				<Box width="100%" height="25em">
					<SzBackdrop message="načítám obrázky" />
				</Box>
			}
		>
			<QueryErrorResetBoundary>
				{() => (
					<ErrorBoundary
						fallbackRender={() => (
							<Box
								sx={{
									display: "flex",
									marginTop: "2rem",
									backgroundColor: "grey.200",
									borderRadius: 10,
									justifyContent: "center",
									alignItems: "center",
									fontSize: "10rem",
								}}
							>
								<HideImage color="disabled" fontSize="inherit" />
							</Box>
						)}
					>
						<Images id={id} />
					</ErrorBoundary>
				)}
			</QueryErrorResetBoundary>
		</Suspense>
	);
};

export default ImagesSection;
